import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { Typography, CircularProgress, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";
import CreditsFiltered from "./CreditsFiltered";
import { TOP_FIXED_RATE_SETTINGS } from "./topConditionsConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1000,
    marginLeft: "auto",
    marginRight: "auto"
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(2),
  },
  progress: theme.progress,
}));

export default function PotentialRefinancing() {
  const classes = useStyles();
  const history = useHistory();
  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);
  const [credits, setCredits] = useState([]);
  const [topConditions, setTopConditions] = useState({});
  const [showSnoozedCredits, setShowSnoozedCredits] = useState(false);

  useEffect(() => {
    getCredits();
    getTopConditions();
    pageContext.setIsLoading(true);
  }, []);

  const getCredits = () => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/status/successful`,
      method: "get",
      headers: userContext.getRequestAuthHeader()
    };

    axios(options)
      .then((res) => {
        setCredits(res.data);
        pageContext.setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        pageContext.setIsLoading(false);
      });
  };

  const getTopConditions = () => {
    Promise.all(TOP_FIXED_RATE_SETTINGS.map((setting) => {
      return axios({
        url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/${setting.type}/${setting.key}`,
        method: "get",
        headers: userContext.getRequestAuthHeader()
      });
    }))
      .then((responses) => {
        const loadedSettings = {};
        responses.forEach(({ data }) => {
          loadedSettings[data.key] = data;
        });
        setTopConditions(loadedSettings);
      })
      .catch(() => {
        // fail silently
      });
  };

  const deleteCredit = (editingCredit) => {
    pageContext.setConfirmDialog({
      open: true,
      title: "Wirklich löschen?",
      message:
        "Bist du dir sicher, dass du die Finanzierung " +
        (editingCredit.name ? editingCredit.name : "") +
        " löschen möchtest?",
      handleYes: () => {
        pageContext.setConfirmDialog({
          open: false,
        });
        const options = {
          url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${editingCredit.id}`,
          method: "delete",
          headers: userContext.getRequestAuthHeader()
        };
        axios(options)
          .then((res) => {
            getCredits();
            pageContext.setInfoMessage("Finanzierung wurde gelöscht");
          })
          .catch((err) => {
            console.log(err);
            pageContext.setErrorMessage("Finanzierung konnte nicht gelöscht werden!");
          });
      },
      handleNo: () => {
        pageContext.setConfirmDialog({
          open: false,
        });
      },
    });
  };

  if (!credits || pageContext.isLoading) {
    return <>
      <CircularProgress
        className={classes.progress}
        color="secondary"
      />
    </>;
  }

  return (
    <div className={classes.root}>
      <div className={classes.headerRow}>
        <Typography variant="h2">Potenzielle Umschuldungen</Typography>
        <Button
          variant="contained"
          color="primary"
          size="small"
          aria-label="alle kredite"
          onClick={() => {
            history.push("/finanzierungsarchiv/");
          }}
        >
          Alle Kredite
        </Button>
      </div>
      <br />
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <Button
          variant={showSnoozedCredits ? "contained" : "outlined"}
          color="primary"
          size="small"
          onClick={() => setShowSnoozedCredits(!showSnoozedCredits)}
        >
          {showSnoozedCredits ? "Ausgeblendete ausblenden" : "Ausgeblendete anzeigen"}
        </Button>
      </div>
      <CreditsFiltered
        credits={credits}
        getCredits={getCredits}
        deleteCredit={deleteCredit}
        topConditions={topConditions}
        showSnoozedCredits={showSnoozedCredits}
      />
    </div>
  );
}
